import { AUDIENCE_TRACKING_DOMAINS } from 'constants/apis';

import { performGet } from '../services/rest-service/rest-service';

export const GET_PR_ATTRIBUTIONS = 'pr-attributions/GET_PR_ATTRIBUTIONS';
export const GET_PR_ATTRIBUTIONS_RECEIVED =
  'pr-attributions/GET_PR_ATTRIBUTIONS_RECEIVED';
export const GET_PR_ATTRIBUTIONS_ERROR =
  'pr-attributions/GET_PR_ATTRIBUTIONS_ERROR';

const initialState = {
  error: false,
  loading: false,
  prAttributions: [],
};

const prAttributionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PR_ATTRIBUTIONS:
      return { ...state, loading: true };
    case GET_PR_ATTRIBUTIONS_RECEIVED: {
      return {
        ...state,
        error: false,
        prAttributions: [...action.payload],
        loading: false,
      };
    }
    case GET_PR_ATTRIBUTIONS_ERROR:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};

export const getPrAttributionsActionDispatcher = () => dispatch => {
  dispatch({ type: GET_PR_ATTRIBUTIONS });
  performGet(`${AUDIENCE_TRACKING_DOMAINS}`)
    .then(resp =>
      dispatch({ type: GET_PR_ATTRIBUTIONS_RECEIVED, payload: resp.data }),
    )
    .catch(error =>
      dispatch({ type: GET_PR_ATTRIBUTIONS_ERROR, payload: error }),
    );
};

export default prAttributionsReducer;
